module.exports = __webpack_public_path__ + "img/IND-B-1-III.2e3f7c9b.png";